import { GridSortModel } from "@mui/x-data-grid";
import { GoFlyerAdminState } from "../../../../contextApi/state";
import { FrontPage } from "../../../../utils/constant/stringConstant";
import { toastExcelError, toastWarn } from "../../../../utils/pageUtil/toast";
import { paramCreator } from "../../../../utils/api";
import { readApiError } from "../../../../utils/apiError";
import { waitForReauth } from "../../../../utils/sessionExpiry";

/** Same "all items" ceiling useAllFlyerItems uses; the server takes it as-is. */
const EXPORT_LIMIT = 1000;

export const exportExcelFnV2 = async (
  state: GoFlyerAdminState,
  flyerItemListId: string,
  gridSortModel: GridSortModel,
  Authorization: string,
  selectedCategories?: string[],
  listTotal?: number
) => {
  const categoryList =
    selectedCategories ||
    state.user?.gfFlyerItemCategory?.map((value) => `${value.id}`);

  const FlyerItemCategoryList = categoryList?.filter(
    (category) => category !== FrontPage && category !== "undefined"
  );

  const topSale = categoryList?.includes(FrontPage);
  const page = 1;

  const orderBy = gridSortModel?.length
    ? {
        topSale: "DESC",
        [`${gridSortModel[0].field}`]: `${gridSortModel[0]?.sort?.toUpperCase()}`,
      }
    : {
        topSale: "DESC",
        updatedAt: "DESC",
      };

  const requestExport = (authorization: string) => {
    const { url, options } = paramCreator.gfFlyerItemAdminControllerExportExcel(
      page,
      EXPORT_LIMIT,
      JSON.stringify({ orderBy }),
      flyerItemListId,
      !!topSale,
      FlyerItemCategoryList && FlyerItemCategoryList.length
        ? FlyerItemCategoryList
        : undefined,
      {
        headers: {
          Authorization: authorization,
        },
      }
    );
    return fetch(process.env.REACT_APP_GOFLYER_API_END_POINT + url, {
      ...options,
    });
  };

  try {
    let response = await requestExport(Authorization);

    // Expired login: sign in again in place, then retry once with the new token.
    if (response.status === 401) {
      const newToken = await waitForReauth();
      if (!newToken) return;
      response = await requestExport(`Bearer ${newToken}`);
    }

    if (!response.ok) {
      const { status, message } = await readApiError(response);
      toastWarn(
        status === 404
          ? `${message} for the selected categories`
          : `Export failed: ${message}`
      );
      return;
    }

    const blob = await response.blob();

    const name = response.headers.get("X-File-Name");
    const fileName = decodeURIComponent(name ?? "flyer-items.xlsx");

    const blobUrl = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = blobUrl;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(blobUrl);

    if (listTotal && listTotal > EXPORT_LIMIT) {
      toastWarn(
        `This list has ${listTotal} items. Exports include up to ${EXPORT_LIMIT}, so some may be missing.`
      );
    }
  } catch (error) {
    toastExcelError("Failed to export Excel file");
    console.error("Download failed:", error);
  }
};
